import React from 'react'
import { FormikCents } from 'donate/shared'

export const Sum = () => {
  return (
    <>
      <div className="mt-4 mb-12 text-center desktop:text-left">
        <span className="text-lg font-bold block desktop:inline desktop:mr-3">
          <span className="mr-1">{i18n.t('donate.codonation_box.sum_label')}</span>
          <FormikCents fields={['amount_cents', 'codonation_cents']} />
        </span>
        <span className="text-gray-700 italic">{i18n.t('donate.codonation_box.thank_you')}</span>
      </div>
    </>
  )
}
